<template>
    <component
        :is="navigationComponent"
        :entries="navigation"
        :settings="settings"
        :has-banner="hasBannerImage"
        :home-uri="homeUri"
        :show-search="!isMicrosite"
        :google-translate-settings="googleTranslateSettings"
    >
        <template #logo="navigationProps">
            <img v-if="navigationProps.sticky" :src="stickyHeaderLogo[0]?.url ?? headerLogo[0]?.url" :alt="`${variables?.siteName} logo`" :class="stickyLogoSize">
            <img v-else-if="!navigationProps.sticky && displayHeaderLogo" :src="headerLogo[0]?.url" :alt="`${variables?.siteName} logo`" :class="logoSize">
        </template>
    </component>
</template>

<script setup>
    const pageType = inject('page-type', 'home')

    const {
        homeUri,
        navigation,
        globalSets,
        digistormSettings,
        variables,
        getGlobalSetField,
        isMicrosite,
    } = storeToRefs(useSiteStore())

    const navigationType = computed(() => {
        return digistormSettings.value.navType
    })

    const settings = computed(() => {
        const navigationSet = find(globalSets.value, { __typename: 'ds_Navigation_GlobalSet'})

        return {
            ...Object.entries(navigationSet).reduce((acc, [key]) => {
                acc[key] = getGlobalSetField.value('ds_Navigation_GlobalSet', key)
                return acc
            }, {})
        }
    })


    const googleTranslateSettings = computed(() => {
        // Find the ds_GoogleTranslate_GlobalSet in globalSets
        const googleTranslateSet = find(globalSets.value, { __typename: 'ds_GoogleTranslate_GlobalSet' })

        if (!googleTranslateSet?.googleTranslate_OptionsValue) {
            return {
                toggle: false,
                options: [],
            }
        }

        // Combine googleTranslate_Options and googleTranslate_OptionsValue
        const options = googleTranslateSet.googleTranslate_OptionsValue.map((code, index) => ({
            code,
            name: googleTranslateSet.googleTranslate_Options[index],
        }))

        return {
            toggle: googleTranslateSet.googleTranslate_Toggle,
            options,
        }
    })

    const hasBannerImage = computed(() => {
        // we don't have access to the banner data at this level anymore.
        // it's save to assume all homepages have a banner
        return true
    })

    const navigationComponent = defineAsyncComponent(() =>
        import(`./${pageType}/${navigationType.value}/nav.async.vue`)
    )

    const headerLogo = computed(() => {
        return getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_HeaderLogo', true)
    })

    const logoSize = computed(() => {
        return logoScale(getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_HeaderLogoSize', true))
    })

    const stickyHeaderLogo = computed(() => {
        return getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_StickyNavLogo', true)
    })

    const stickyLogoSize = computed(() => {
        return logoScale(getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_StickyNavLogoSize', true))
    })

    const bannerType = computed(() => {
        return digistormSettings.value.bannerType
    })

    // only hide the logo on the homepage
    const displayHeaderLogo = computed(() => {
        return bannerType.value !== 'banner-b' || pageType !== 'home'
    })

    const logoScale = (size) => {
        switch(size) {
            case 'sm':
                return 'scale-50'
            case 'lg':
                return 'scale-150'
            case 'md':
            default:
                return ''
        }
    }

</script>

<style lang="scss" scoped>

</style>
